import script from "./DeptChart.vue?vue&type=script&lang=js"
export * from "./DeptChart.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__